import * as React from "react";
import Box from "@mui/material/Box";

/**
 * DataViz 
 * ----------------------------------------------------------

 */

// ---------- Component ----------
export default function DataViz() {
 
  return (
    <Box sx={{ p: { xs: 2, md: 3 }, bgcolor: 'background.default', minHeight: '100vh' }}>
      <h1>Home of Future DataViz haha</h1>

    </Box>
  );
}
